/**
 * 订单相关接口
 */
const api = '/checkmall-order/api'
export default {
    // 用户创建订单
    orderAdd: api + '/order/add',
    // 订单列表
    orderIndex: api + '/order/getList',
    // 我要送检的流程信息、订单管理--详情数据
    stepInfo: api + '/order/orderInfo',
    // 订单更新
    updateOrder: api + '/order/updateOrderInfo',
    // 订单提交
    submitOrder: api + '/order/submit',
    // 订单删除
    orderDel: api + '/order/deleteOrder',
    //订单驳回、确认
    orderReview: api + '/order/review',
    // 订单详情--物流信息、审核记录timeline
    getTimeLine: api + '/order/orderInfoByStepKey',
    // 订单获取价格、失败原因
    getOrderExtra: api+'/order/getOrderExtra',
    // 样品详情--检项列表
    getPrjBySample: api + '/order/moduleInfo',
    //选择添加样品和检项
    addSampleBySelect: api + '/order/addGoods',
    //手动添加样品、编辑样品--表单+检项的字段配置
    getConfig: api + '/order/orderInfoToMap',
    //样品编辑-添加检项
    sampleAddPrj: api + '/order/addProjects',
    // 手动添加样品--删除检项
    sampleInfoDelPrj: api + '/order/deleteProjects',
    // 手动添加样品
    addSampleByHand: api + '/order/addGoodsByUser',
    // 删除样品
    delSample: api + '/order/deleteGoods',
    // 加入购物车
    addCart: api + '/cart/add',
    //购物车列表
    cartList: api + '/cart/list',
    // 购物车--编辑样品详情
    cartSampleDetail: api + '/cart/getCartInfo',
    // 取消购物车
    cartDel: api + '/cart/delete',
    // 购物车--修改样品保存
    cartSaveSample: api + '/cart/updateCartInfo',
    // 购物车--提交
    cartSubmit: api + '/cart/createOrder',
    // 报告查询
    searchReport: '/checkmall-order/lims/order/getLimsOrder',
    // 我的报告
    myReport: api + '/order/getReportlist',
    // 大列表--查看报告
    getReport:'/checkmall-order/lims/order/searchGoodsReport',
    // 大列表--查看委托单
    myEntrustPdf: api + '/order/searchEntrustPdf',
    // 信息复核后--生成委托单
    getEntrustBill: api + '/order/getEntrustBill',
    // 购物车--删除检项
    cartDelPrj: api + '/cart/deleteProjects',
    // 购物车--添加检项
    cartAddPrj: api + '/cart/addProject',
    // 再次送检
    copyOrder: api + '/order/copyOrder',
    // 撤回订单
    withdraw: api + '/order/withdraw',
    // 复制样品
    copyGoods: api + '/order/copyGoods'
};